import Instance from "../../../../Axios";

// New Actions for the app

const GetCredTipoCartoes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/tipoCartoes`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_TIPO_CARTOES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredTipoCartoes;
